// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var ImportEnrichmentRuleCodec$ReactHooksTemplate = require("./ImportEnrichmentRuleCodec.res.js");
var ImportEnrichmentRuleTypes$ReactHooksTemplate = require("./ImportEnrichmentRuleTypes.res.js");
var ImportEnrichmentSimulationInputs$ReactHooksTemplate = require("./ImportEnrichmentSimulationInputs.res.js");
var ImportEnrichmentSimulationFixture$ReactHooksTemplate = require("./ImportEnrichmentSimulationFixture.res.js");

function getBool(obj, key, defaultValue) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(obj, key), Js_json.decodeBoolean), defaultValue);
}

function getInt(obj, key, defaultValue) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(obj, key), (function (json) {
                    var number = Js_json.decodeNumber(json);
                    if (number !== undefined) {
                      return number | 0;
                    } else {
                      return Belt_Option.flatMap(Js_json.decodeString(json), Belt_Int.fromString);
                    }
                  })), defaultValue);
}

var emptyJsonArray = Caml_array.make(0, null);

function formatJsonValue(json) {
  if (json === undefined) {
    return "(empty)";
  }
  var s = Js_json.classify(json);
  if (typeof s !== "object") {
    switch (s) {
      case "JSONFalse" :
          return "false";
      case "JSONTrue" :
          return "true";
      case "JSONNull" :
          return "(empty)";
      
    }
  } else {
    switch (s.TAG) {
      case "JSONString" :
          var s$1 = s._0;
          if (s$1 === "") {
            return "(empty)";
          } else {
            return s$1;
          }
      case "JSONNumber" :
          return s._0.toString();
      case "JSONObject" :
      case "JSONArray" :
          return JSON.stringify(json);
      
    }
  }
}

function getArray(obj, key) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(obj, key), Js_json.decodeArray), emptyJsonArray);
}

function nodeStatusClass(status) {
  switch (status) {
    case "failed" :
        return "border-red-300 bg-red-50";
    case "applied" :
    case "passed" :
        return "border-green-300 bg-green-50";
    case "skipped" :
        return "border-yellow-300 bg-yellow-50";
    default:
      return "border-gray-200 bg-white";
  }
}

function nodeStatusIcon(status) {
  switch (status) {
    case "failed" :
        return "✗";
    case "applied" :
    case "passed" :
        return "✓";
    case "skipped" :
        return "⊘";
    default:
      return "•";
  }
}

function formatTraceNodeLabel(nodeObj) {
  var nodeType = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "type", "");
  switch (nodeType) {
    case "action" :
        var effect = Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(Js_dict.get(nodeObj, "effect"), Js_json.decodeObject), (function (obj) {
                    return Belt_Option.flatMap(Js_dict.get(obj, "path"), Js_json.decodeString);
                  })), "action");
        return "Write " + effect;
    case "condition" :
        var path = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "path", "");
        var op = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "op", "");
        var expected = Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(Js_dict.get(nodeObj, "resolved"), Js_json.decodeObject), (function (obj) {
                    return Belt_Option.flatMap(Js_dict.get(obj, "right"), Js_json.decodeString);
                  })), "");
        var expectedSuffix = expected === "" ? "" : " \"" + expected + "\"";
        return path + " " + ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel(op) + expectedSuffix;
    default:
      return ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "id", "node");
  }
}

function renderExplanation(nodeObj) {
  var explanation = Belt_Option.flatMap(Js_dict.get(nodeObj, "explanation"), Js_json.decodeObject);
  if (explanation === undefined) {
    return null;
  }
  var summary = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(explanation, "summary", "");
  var facts = getArray(explanation, "facts");
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                      children: summary,
                      className: "font-medium text-gray-800"
                    }),
                Belt_Array.map(facts, (function (factJson) {
                        var fact = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(factJson);
                        var label = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(fact, "label", "");
                        var value = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(fact, "value", "");
                        return JsxRuntime.jsxs("p", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: label + ": ",
                                            className: "font-medium"
                                          }),
                                      value
                                    ]
                                  }, label + value);
                      }))
              ],
              className: "mt-2 text-xs text-gray-600 space-y-1"
            });
}

function renderTraceNode(nodeJson, selected, onSelect) {
  var nodeObj = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(nodeJson);
  var nodeId = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "id", "");
  var match = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "type", "");
  var status;
  switch (match) {
    case "action" :
        status = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "status", "skipped");
        break;
    case "condition" :
        status = getBool(nodeObj, "matched", false) ? "passed" : "failed";
        break;
    default:
      status = "unknown";
  }
  var match$1 = Belt_Option.flatMap(Js_dict.get(nodeObj, "type"), Js_json.decodeString);
  var tmp;
  if (match$1 === "action") {
    var resolvedJson = Js_dict.get(nodeObj, "resolved_value");
    if (resolvedJson !== undefined) {
      var value = formatJsonValue(resolvedJson);
      tmp = value === "(empty)" ? null : JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                      children: "Resolved: ",
                      className: "font-medium"
                    }),
                value
              ],
              className: "mt-1 text-xs text-gray-600"
            });
    } else {
      tmp = null;
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("button", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("span", {
                            children: nodeStatusIcon(status),
                            className: "text-sm font-bold shrink-0"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "type", "node"),
                                    className: "text-xs font-semibold uppercase tracking-wide text-gray-500"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: formatTraceNodeLabel(nodeObj),
                                    className: "text-sm text-gray-900 break-words"
                                  }),
                              selected ? renderExplanation(nodeObj) : null,
                              tmp
                            ],
                            className: "min-w-0 flex-1"
                          })
                    ],
                    className: "flex items-start gap-2"
                  }),
              className: "w-full text-left rounded-lg border p-3 transition-colors " + nodeStatusClass(status) + " " + (
                selected ? "ring-2 ring-blue-500" : ""
              ),
              type: "button",
              onClick: (function (param) {
                  Curry._1(onSelect, undefined);
                })
            }, nodeId);
}

function renderGroupSummary(groupJson) {
  var group = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(groupJson);
  var operator = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(group, "operator", "all");
  var matched = getBool(group, "matched", false);
  var shortCircuited = getBool(group, "short_circuited", false);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("span", {
                      children: operator + " group",
                      className: "font-semibold uppercase"
                    }),
                JsxRuntime.jsx("span", {
                      children: matched ? "matched" : "did not match",
                      className: "mx-2"
                    }),
                shortCircuited ? JsxRuntime.jsx("span", {
                        children: "(short-circuited)",
                        className: "text-gray-500"
                      }) : null
              ],
              className: "rounded-lg border border-dashed border-gray-300 bg-gray-50 px-3 py-2 text-xs text-gray-600"
            });
}

function renderDiff(diffJson) {
  var entries = Belt_Option.getWithDefault(Js_json.decodeArray(diffJson), emptyJsonArray);
  if (entries.length === 0) {
    return JsxRuntime.jsx("p", {
                children: "No field changes in this simulation.",
                className: "text-sm text-gray-500"
              });
  } else {
    return JsxRuntime.jsx("div", {
                children: Belt_Array.map(entries, (function (entryJson) {
                        var entry = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(entryJson);
                        var path = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(entry, "path", "");
                        var before = formatJsonValue(Js_dict.get(entry, "before"));
                        var after = formatJsonValue(Js_dict.get(entry, "after"));
                        return JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("p", {
                                            children: path,
                                            className: "font-mono text-xs text-gray-500 mb-1"
                                          }),
                                      JsxRuntime.jsx("p", {
                                            children: before + " → " + after,
                                            className: "text-gray-800"
                                          })
                                    ],
                                    className: "rounded-lg border border-gray-200 bg-white p-3 text-sm"
                                  }, path);
                      })),
                className: "space-y-2"
              });
  }
}

function renderVariables(variablesJson) {
  var variables = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(variablesJson);
  var referenced = getArray(variables, "referenced");
  var changed = getArray(variables, "changed");
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "Referenced paths",
                              className: "text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2"
                            }),
                        referenced.length === 0 ? JsxRuntime.jsx("p", {
                                children: "No referenced paths.",
                                className: "text-sm text-gray-500"
                              }) : JsxRuntime.jsx("div", {
                                children: Belt_Array.map(referenced, (function (itemJson) {
                                        var item = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(itemJson);
                                        var path = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(item, "path", "");
                                        var value = formatJsonValue(Js_dict.get(item, "value"));
                                        return JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: path,
                                                            className: "text-gray-500"
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: value,
                                                            className: "text-gray-900"
                                                          })
                                                    ],
                                                    className: "rounded border border-gray-200 bg-white px-3 py-2 text-xs font-mono"
                                                  }, path);
                                      })),
                                className: "space-y-2"
                              })
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "Changed fields",
                              className: "text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2"
                            }),
                        renderDiff(changed)
                      ]
                    })
              ],
              className: "space-y-4"
            });
}

function renderTestInputs(fieldInputs, simulationInputs, dispatch) {
  if (Belt_List.length(fieldInputs) === 0) {
    return JsxRuntime.jsx("div", {
                children: "Add at least one condition or an action that reads a field to configure test inputs.",
                className: "rounded-xl border border-dashed border-gray-300 bg-white p-5 text-sm text-gray-600"
              });
  }
  var grouped = ImportEnrichmentSimulationInputs$ReactHooksTemplate.groupFieldInputs(fieldInputs);
  return JsxRuntime.jsx("div", {
              children: $$Array.of_list(Belt_List.map(grouped, (function (param) {
                          var bucket = param[0];
                          return JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("p", {
                                              children: bucket,
                                              className: "text-xs font-bold uppercase tracking-wider text-gray-500 mb-3"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: $$Array.of_list(Belt_List.map(param[1], (function (input) {
                                                          return JsxRuntime.jsxs("div", {
                                                                      children: [
                                                                        JsxRuntime.jsx("label", {
                                                                              children: input.label,
                                                                              className: "block text-sm font-medium text-gray-700 mb-1.5"
                                                                            }),
                                                                        JsxRuntime.jsx("input", {
                                                                              className: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white",
                                                                              placeholder: input.placeholder,
                                                                              type: "text",
                                                                              value: ImportEnrichmentSimulationFixture$ReactHooksTemplate.getInputValue(simulationInputs, input.path),
                                                                              onChange: (function (e) {
                                                                                  Curry._1(dispatch, {
                                                                                        TAG: "SetSimulationInput",
                                                                                        _0: input.path,
                                                                                        _1: e.target.value
                                                                                      });
                                                                                })
                                                                            })
                                                                      ]
                                                                    }, input.path);
                                                        }))),
                                              className: "grid grid-cols-1 md:grid-cols-2 gap-3"
                                            })
                                      ]
                                    }, bucket);
                        }))),
              className: "space-y-5"
            });
}

function ImportEnrichmentRuleSimulator(props) {
  var onSimulate = props.onSimulate;
  var dispatch = props.dispatch;
  var state = props.state;
  var fieldInputs = ImportEnrichmentSimulationInputs$ReactHooksTemplate.buildFieldInputs(props.conditions, props.actions, state.fieldOptions);
  var simulation = Belt_Option.getWithDefault(Belt_Option.map(state.simulationResult, ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject), {});
  var verdict = Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(simulation, "verdict"), Js_json.decodeObject), {});
  var trace = Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(simulation, "trace"), Js_json.decodeObject), {});
  var traceNodes = getArray(trace, "nodes");
  var traceGroups = getArray(trace, "groups");
  var ruleMatched = getBool(verdict, "rule_matched", getBool(simulation, "rule_matched", false));
  var actionsExecuted = String(getInt(verdict, "actions_executed", 0));
  var actionsSkipped = String(getInt(verdict, "actions_skipped", 0));
  var id = state.simulationSelection;
  var selectedNodeId;
  selectedNodeId = typeof id !== "object" ? props.highlightedNodeId : id._0;
  var viewTabClass = function (active) {
    return "px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors " + (
            active ? "bg-blue-600 text-white" : "bg-white text-gray-600 border border-gray-200 hover:bg-gray-50"
          );
  };
  var tmp;
  if (Belt_Option.isSome(state.simulationResult)) {
    var match = state.simulationView;
    var tmp$1;
    switch (match) {
      case "TraceView" :
          tmp$1 = JsxRuntime.jsxs("div", {
                children: [
                  Belt_Array.map(traceGroups, (function (groupJson) {
                          var group = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(groupJson);
                          var groupId = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(group, "id", "");
                          return JsxRuntime.jsx("div", {
                                      children: renderGroupSummary(groupJson)
                                    }, groupId);
                        })),
                  Belt_Array.map(traceNodes, (function (nodeJson) {
                          var nodeObj = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(nodeJson);
                          var nodeId = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(nodeObj, "id", "");
                          return renderTraceNode(nodeJson, Caml_obj.equal(selectedNodeId, nodeId), (function (param) {
                                        Curry._1(dispatch, {
                                              TAG: "SetSimulationSelection",
                                              _0: {
                                                TAG: "SelectedNode",
                                                _0: nodeId
                                              }
                                            });
                                      }));
                        }))
                ],
                className: "space-y-3"
              });
          break;
      case "VariablesView" :
          var variablesJson = Js_dict.get(simulation, "variables");
          tmp$1 = variablesJson !== undefined ? renderVariables(variablesJson) : JsxRuntime.jsx("p", {
                  children: "No variable snapshot available.",
                  className: "text-sm text-gray-500"
                });
          break;
      case "DiffView" :
          var diffJson = Js_dict.get(simulation, "diff");
          tmp$1 = diffJson !== undefined ? renderDiff(diffJson) : JsxRuntime.jsx("p", {
                  children: "No diff available.",
                  className: "text-sm text-gray-500"
                });
          break;
      
    }
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                          children: ruleMatched ? "Rule would run" : "Rule would not run",
                          className: "text-sm font-semibold text-gray-900"
                        }),
                    JsxRuntime.jsx("p", {
                          children: "Actions applied: " + actionsExecuted + " • Skipped: " + actionsSkipped,
                          className: "text-xs text-gray-600 mt-1"
                        })
                  ],
                  className: "rounded-xl border p-4 " + (
                    ruleMatched ? "border-green-300 bg-green-50" : "border-red-300 bg-red-50"
                  )
                }),
            tmp$1,
            Belt_List.length(state.simulationHistory) > 0 ? JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("p", {
                            children: "Recent runs (this session)",
                            className: "text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2"
                          }),
                      JsxRuntime.jsx("div", {
                            children: $$Array.of_list(Belt_List.map(state.simulationHistory, (function (run) {
                                        var time = new Date(run.ranAt).toLocaleTimeString();
                                        return JsxRuntime.jsx("button", {
                                                    children: time + " • " + (
                                                      run.ruleMatched ? "match" : "no match"
                                                    ),
                                                    className: "px-3 py-1.5 text-xs rounded-lg border border-gray-200 bg-white hover:bg-gray-50",
                                                    type: "button",
                                                    onClick: (function (param) {
                                                        Curry._1(dispatch, {
                                                              TAG: "SetSimulationInputs",
                                                              _0: ImportEnrichmentSimulationFixture$ReactHooksTemplate.cloneInputs(run.inputs)
                                                            });
                                                        Curry._1(dispatch, {
                                                              TAG: "SetSimulationResult",
                                                              _0: run.resultJson
                                                            });
                                                      })
                                                  }, run.id);
                                      }))),
                            className: "flex flex-wrap gap-2"
                          })
                    ]
                  }) : null
          ],
          className: "space-y-4"
        });
  } else {
    tmp = JsxRuntime.jsx("p", {
          children: "Run a simulation to see condition traces, action effects, and field diffs.",
          className: "text-sm text-gray-500"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "Test inputs",
                              className: "text-sm font-medium text-gray-800 mb-1"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Enter sample values for the fields your rule reads. You do not need to edit JSON.",
                              className: "text-xs text-gray-500 mb-3"
                            }),
                        renderTestInputs(fieldInputs, state.simulationInputs, dispatch)
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: state.simulating ? "Simulating..." : "Simulate",
                              className: "inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-medium text-sm text-white transition-opacity " + (
                                state.simulating ? "bg-blue-400 cursor-wait" : "bg-iguanagreen hover:opacity-90"
                              ),
                              disabled: state.simulating || Belt_List.length(fieldInputs) === 0,
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onSimulate, undefined);
                                })
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: "Trace",
                                      className: viewTabClass(state.simulationView === "TraceView"),
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(dispatch, {
                                                TAG: "SetSimulationView",
                                                _0: "TraceView"
                                              });
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: "Variables",
                                      className: viewTabClass(state.simulationView === "VariablesView"),
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(dispatch, {
                                                TAG: "SetSimulationView",
                                                _0: "VariablesView"
                                              });
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: "Diff",
                                      className: viewTabClass(state.simulationView === "DiffView"),
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(dispatch, {
                                                TAG: "SetSimulationView",
                                                _0: "DiffView"
                                              });
                                        })
                                    })
                              ],
                              className: "flex gap-2"
                            })
                      ],
                      className: "flex flex-wrap items-center gap-3"
                    }),
                tmp
              ],
              className: "space-y-4"
            });
}

var decodeObject = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject;

var getString = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString;

var groupFieldInputs = ImportEnrichmentSimulationInputs$ReactHooksTemplate.groupFieldInputs;

var make = ImportEnrichmentRuleSimulator;

exports.decodeObject = decodeObject;
exports.getString = getString;
exports.getBool = getBool;
exports.getInt = getInt;
exports.emptyJsonArray = emptyJsonArray;
exports.formatJsonValue = formatJsonValue;
exports.getArray = getArray;
exports.nodeStatusClass = nodeStatusClass;
exports.nodeStatusIcon = nodeStatusIcon;
exports.formatTraceNodeLabel = formatTraceNodeLabel;
exports.renderExplanation = renderExplanation;
exports.renderTraceNode = renderTraceNode;
exports.renderGroupSummary = renderGroupSummary;
exports.renderDiff = renderDiff;
exports.renderVariables = renderVariables;
exports.groupFieldInputs = groupFieldInputs;
exports.renderTestInputs = renderTestInputs;
exports.make = make;
/* emptyJsonArray Not a pure module */
